var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticStyle:{"color":"#ffffff","border":"1px solid white !important"},attrs:{"size":"35","color":"teal"}},[_vm._v(" "+_vm._s(_vm.initial)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }